import { useQuery } from '@tanstack/react-query';
import { Meta } from '@/store/Announcement/types';
import api from '../../../services/api';

export const QUERY_EXCEL_EXPORT = 'QUERY_EXCEL_EXPORT';

export type TypeExcel =
    | 'stores'
    | 'sales'
    | 'stock'
    | 'sales-by-transaction'
    | 'product-global'
    | 'planogram'
    | 'planogram_stock'
    | 'product'
    | 'invoice'
    | 'churn-monitoring'
    | 'category';

export type ExcelExportParams = {
    userId: number | null | undefined;
    type?: TypeExcel;
    storeId?: number;
    storeIds?: number[];
    page?: number;
    perPage?: number;
};

interface Params {
    field: string;
    finalDate: string;
    initialDate: string;
    transactionStatus?: string;
    storeId?: number;
    productIds?: Array<number>;
}

interface UploadedFile {
    id: string;
    storage: string;
    bucket: string;
    source: string;
    path: string;
    url: string;
    name: string;
    size: number;
    mime_type: string;
    is_public: boolean;
    created_by_user_id: number;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}

interface CreatedByUser {
    id: number;
    email: string;
    shopManager: any;
}

enum ExportStatus {
    Completed = 'completed',
    Pending = 'pending',
    Processing = 'processing',
    Error = 'error',
}

const DEFAULT_REFRESH_INTERVAL = 1 * 10000; // 10 seconds
export interface ExcellExportResponse {
    id: number;
    created_by_user_id: number;
    status: ExportStatus;
    type: string;
    params: Params;
    result_type: string;
    uploaded_file_id: string;
    started_at: string;
    finished_at: string;
    created_at: string;
    updated_at: string;
    uploadedFile: UploadedFile;
    createdByUser: CreatedByUser;
}

export interface PropsResponse {
    data: ExcellExportResponse[];
    meta: Meta;
}

export function useExcelExport({
    userId,
    storeId,
    type,
    page = 1,
    perPage = 3,
}: ExcelExportParams) {
    const getExcelExport = async () => {
        const response = await api.get<PropsResponse>('/reports/v2/list', {
            params: {
                page,
                perPage,
                type: type ?? 'sales',
                storeId,
            },
        });

        return response.data;
    };

    return useQuery({
        queryKey: [QUERY_EXCEL_EXPORT, userId, storeId, type, page, perPage],
        queryFn: getExcelExport,
        refetchOnWindowFocus: false,
        refetchInterval: (data) => {
            const hasPending = data?.data?.some(
                (item) =>
                    item.status === ExportStatus.Pending ||
                    item.status === ExportStatus.Processing,
            );

            return hasPending ? DEFAULT_REFRESH_INTERVAL : false;
        },
    });
}
